import { ProductPriceData } from "@domain/product/product-price-data";

export interface TableRow {
  position: string;
  quantity: string;
  name: string;
  id: string;
  priceData?: ProductPriceData;
  discount?: number;
  totalCosts?: number;
  showWarning: boolean;
  isPlaceholder: boolean;
}

export class ProductTableRow implements TableRow {
  position: string;
  quantity: string;
  name: string;
  id: string;
  priceData?: ProductPriceData | undefined;
  discount?: number;
  totalCosts?: number;
  showWarning: boolean;
  isPlaceholder: boolean;

  constructor(
    position: string,
    quantity: string,
    name: string,
    id: string,
    showWarning: boolean,
    isPlaceholder: boolean,
    totalCosts?: number,
    priceData?: ProductPriceData,
    discount?: number,
  ) {
    this.position = position;
    this.quantity = quantity;
    this.name = name;
    this.id = id;
    this.priceData = priceData;
    this.discount = discount;
    this.totalCosts = totalCosts;
    this.showWarning = showWarning;
    this.isPlaceholder = isPlaceholder;
  }
}
